export default __webpack_public_path__ + "static/media/templateEmpty.7af8e0ef.svg";